import { render } from "./PessoaIdentityHeader.vue?vue&type=template&id=26e218c5&scoped=true"
import script from "./PessoaIdentityHeader.vue?vue&type=script&lang=js"
export * from "./PessoaIdentityHeader.vue?vue&type=script&lang=js"

import "./PessoaIdentityHeader.vue?vue&type=style&index=0&id=26e218c5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e218c5"]])

export default __exports__